module.exports = __webpack_public_path__ + "static/media/logoorange.5ecb011c.png";